import actionTypes from './actionTypes';

const refreshFeatureFlags = dispatch => (payload) => {
  dispatch({ payload, type: actionTypes.REFRESH });
};

export default {
  refreshFeatureFlags,
};
